<template>
  <div class="row">
    <div class="col-12">
      <div class="element-wrapper">
        <!--h6 class="element-header">Productos</h6-->
        <div class="element-box">
          <ProductoSelectComponent :current="productoSeleccionadoComponent"></ProductoSelectComponent>
          <button class="btn btn-info" type="button">Buscar</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="element-box" v-if="productoSeleccionadoComponent.sku != null">
        <div class="element-info">
          <div class="row align-items-center">
            <div class="col-sm-12">
              <div class="element-info-with-icon">
                <div class="element-info-icon">
                  <div class="os-icon os-icon-wallet-loaded"></div>
                </div>
                <div class="element-info-text">
                  <h5 class="element-inner-header">{{ productoSeleccionado.nombre }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-7 col-xl-7">
            <div class="row">
              <div class="col-sm-6 b-r b-b">
                <div class="el-tablo centered padded">
                  <div class="value">3814</div>
                  <div class="label">Unidades Vendidos</div>
                </div>
              </div>
              <div class="col-sm-6 b-b">
                <div class="el-tablo centered padded">
                  <div class="value">Q 47.5K</div>
                  <div class="label">Total Vendido</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 b-r">
                <div class="el-tablo centered padded">
                  <div class="value">12</div>
                  <div class="label">Inventario Actual (Total)</div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="el-tablo centered padded">
                  <div class="value">Q 95</div>
                  <div class="label">Venta Promedia Diaria</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5 col-xl-5">
            <div class="padded b-l ">
              <div class="element-info-with-icon smaller">
                <div class="element-info-icon">
                  <div class="os-icon os-icon-bar-chart-stats-up"></div>
                </div>
                <div class="element-info-text">
                  <h5 class="element-inner-header">Monthly Revenue</h5>
                  <div class="element-inner-desc">Calculated every month</div>
                </div>
              </div>
              <div class="os-progress-bar primary">
                <div class="bar-labels">
                  <div class="bar-label-left">
                    <span>Accessories</span>
                    <span class="positive">+10</span>
                  </div>
                  <div class="bar-label-right">
                    <span class="info">72/100</span>
                  </div>
                </div>
                <div class="bar-level-1" style="width: 100%">
                  <div class="bar-level-2" style="width: 60%">
                    <div class="bar-level-3" style="width: 20%"></div>
                  </div>
                </div>
              </div>
              <div class="os-progress-bar primary">
                <div class="bar-labels">
                  <div class="bar-label-left">
                    <span>Shoe Sales</span>
                    <span class="negative">-5</span>
                  </div>
                  <div class="bar-label-right">
                    <span class="info">62/100</span>
                  </div>
                </div>
                <div class="bar-level-1" style="width: 100%">
                  <div class="bar-level-2" style="width: 40%">
                    <div class="bar-level-3" style="width: 10%"></div>
                  </div>
                </div>
              </div>
              <div class="os-progress-bar primary">
                <div class="bar-labels">
                  <div class="bar-label-left">
                    <span>New Customers</span>
                    <span class="positive">+12</span>
                  </div>
                  <div class="bar-label-right">
                    <span class="info">78/100</span>
                  </div>
                </div>
                <div class="bar-level-1" style="width: 100%">
                  <div class="bar-level-2" style="width: 80%">
                    <div class="bar-level-3" style="width: 50%"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-padded">
          <thead>
            <tr>
              <th>Sku</th>
              <th>Nombre del Producto</th>
              <th>Unidad de Medida</th>
              <th class="text-center">Fecha Creacion</th>
              <th class="text-center">Valido Desde</th>
              <th class="text-center">Válido Hasta</th>
              <th class="text-right">Precio</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="current in data.results" v-bind:key="current.id" style="cursor: pointer;">
              <td>{{ current.producto.sku }}</td>
            <td>{{ current.producto.nombre }}</td>
              <td>{{ current.unidad_medida.nombre }}</td>
              <td class="text-center">{{ customFormatter(current.habilitado_desde) }}</td>
              <td class="text-center">{{ customFormatter(current.valido_desde) }}</td>
              <td class="text-center">{{ customFormatter(current.valida_hasta) }}</td>
              <td class="text-right bolder nowrap">
                <span class="text-success">Q {{ current.precio}}</span>
              </td>
              <td>
                <router-link
                  class="btn btn-sm btn-info"
                  :to="{ name: 'cat-lista_precios-editar-precios', params: { id: current.id }}"
                >
                  <i class="fa fa-edit"></i>
                  Editar
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      <AgregarProductoFormComponent :lista_precio="lista_precio" @cerrandomodal="clearFilterData" />
    </div>
  </div>
</template>

<script>
import ProductosService from "@/services/catalogos/ProductosService";

import ListaPrecioFormComponent from "@/components/cat/lista_precios/ListaPrecioFormComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import ListaPreciosProductoService from "@/services/catalogos/ListaPreciosProductoService";
import AgregarProductoFormComponent from "@/components/cat/lista_precios/AgregarProductoFormComponent";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";

export default {
  components: {
    PaginationComponent,
    ListaPrecioFormComponent,
    AgregarProductoFormComponent,
    ProductoSelectComponent
  },
  props: ["lista_precio"],
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: null,
      currentPageProducto: 1,
      searchtextProducto: "",
      filterActivoProducto: null,
      data: [],
      productos: [],
      
      productoSeleccionadoComponent: {
        sku: null,
        errors:[]
      },
      selected: {}
    };
  },
  mounted() {
    let self = this;
    self.refreshData({
      lista_precio: self.lista_precio
    });
    self.refreshDataProductos();
  },
  computed: {
    productoSeleccionado: function(){
      let self = this;
      if (self.productoSeleccionadoComponent.sku == null){
        return null
      }
      return self.productoSeleccionadoComponent;
    },
  },
  methods: {
    onPageChangeProductos(page) {
      this.currentPageProducto = page;
      this.refreshDataProductos({
        page: this.currentPageProducto,
        "filter[search]": this.searchtextProducto,
        estatus: this.filterActivoProducto
      });
    },
    filterDataProductos() {
      let self = this;
      self.currentPageProducto = 1;
      this.refreshDataProductos({
        page: self.currentPageProducto,
        "filter[search]": this.searchtextProducto
      });
    },
    clearFilterDataProducto() {
      this.searchtextProducto = "";
      this.filterActivoProducto = null;
      this.refreshDataProductos({
        page: 1,
        "filter[search]": this.searchtextProducto
      });
      this.productoSeleccionado = null;
      this.refreshData();
    },
    refreshDataProductos(params) {
      let self = this;
      ProductosService.fetch(params).then(res => {
        self.productos = res.data;
        if (self.productos.count == 1){
          self.productoSeleccionado = self.productos.results[0];
          self.rowClickProducto(self.productoSeleccionado);
        }
      });
    },
    keymonitor: function(event) {
      let self = this;
      this.refreshData({
        lista_precio: self.lista_precio,
        page: this.currentPage,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo,
        producto: self.productoSeleccionado.sku
      });
    },
    onPageChange(page) {
      let self = this;
      self.data = [];
      this.currentPage = page;
      this.refreshData({
        lista_precio: self.lista_precio,
        page: this.currentPage,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo,
        producto: self.productoSeleccionado.sku
      });
    },
    filterData() {
      let self = this;
      this.refreshData({
        lista_precio: self.lista_precio,
        page: 1,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo,
        producto: self.productoSeleccionado.sku
      });
    },
    clearFilterData() {
      let self = this;
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        lista_precio: self.lista_precio,
        page: 1,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo,
        producto: self.productoSeleccionado.sku
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      ListaPreciosProductoService.fetch(params).then(res => {
        self.data = res.data;
      });
    },
    customFormatter(date) {
      if (date == "" || date == "None" || date == null) {
        return "No Definida";
      }
      return moment(date).format("DD/MM/YYYY");
    },
    showModalAddProducto() {
      let self = this;
      /*ProveedorService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then(res => {
        self.proveedores = res.data.results;*/
      $("#modalAddProductoPrecio").modal();
      // });
    },
    rowClickProducto(current) {
      let self = this;
      self.productoSeleccionado = current;
      self.refreshData({
        lista_precio: self.lista_precio,
        page: 1,
        "filter[search]": this.searchtext,
        estatus: this.filterActivo,
        producto: self.productoSeleccionado.sku
      });
    }
  }
};
</script>
